import { NgModule } from '@angular/core';
import { FilterByPipe } from "ng/src/app/shared/filter-by.pipe";
import { FormInputDialogComponent } from "ng/src/app/shared/form-input-dialog/form-input-dialog.component";
import { VarDirective } from "ng/src/app/shared/var.directive";
import { TrustHtmlPipe } from './trust-html.pipe';
import { InfiniteTableDirective } from "./infinite-table.directive";
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule } from "primeng/multiselect";
import { ChipModule } from "primeng/chip";
import { TextEditorComponent } from './text-editor/text-editor.component';
import { EditorModule } from 'primeng/editor';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AngularElementEventDirective } from "ng/src/app/shared/events.directive";
import { TableModule } from 'primeng/table';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { MessageModule } from 'primeng/message';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CommentListComponent } from './comment-list/comment-list.component';
import { ExportDialogComponent } from './pdf-export/export-dialog.component';
import { EntityPagerComponent } from './entity-pager/entity-pager.component';
import { CardModule } from 'primeng/card';
import { TrustResourcePipe } from "ng/src/app/shared/trust-resource.pipe";
import { PersistentDialogComponent } from "ng/src/app/shared/persistent-dialog/persistent-dialog.component";
import { MiddleClickDirective } from "ng/src/app/shared/middle-click.directive";
import { PaneledViewerComponent } from "ng/src/app/shared/paneled-viewer/paneled-viewer.component";
import { DividerModule } from "primeng/divider";
import { ResizeObserverDirective } from "ng/src/app/shared/resize-observer/resize-observer.directive";
import { LoadingIndicatorComponent } from "ng/src/app/shared/loading-indicator/loading-indicator.component";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { TooltipModule } from 'primeng/tooltip';
import { AutoCompleteModule } from "primeng/autocomplete";
import { ContainerDirective } from "ng/src/app/shared/container.directive";
import { InplaceEditorComponent } from "ng/src/app/shared/inplace-editor/inplace-editor.component";
import { InplaceModule } from "primeng/inplace";
import { AlertDialogComponent } from "ng/src/app/shared/persistent-dialog/alert-dialog.component";
import { CommandContainerComponent } from './command-palette/command-container/command-container.component';

@NgModule({
    declarations: [
	    TrustHtmlPipe,
	    TrustResourcePipe,
	    FilterByPipe,
			InfiniteTableDirective,
			TextEditorComponent,
			AngularElementEventDirective,
			CommentListComponent,
			ExportDialogComponent,
			EntityPagerComponent,
	    PersistentDialogComponent,
	    MiddleClickDirective,
	    PaneledViewerComponent,
	    ResizeObserverDirective,
	    LoadingIndicatorComponent,
	    ContainerDirective,
	    AlertDialogComponent,
	    ContainerDirective,
	    InplaceEditorComponent,
	    VarDirective,
	    FormInputDialogComponent,
      CommandContainerComponent
    ],
	imports: [
		CommonModule,
		DropdownModule,
		ReactiveFormsModule,
		MultiSelectModule,
		ChipModule,
		EditorModule,
		FormsModule,
		ButtonModule,
		InputTextModule,
		InputTextareaModule,
		InputSwitchModule,
		ConfirmDialogModule,
		TableModule,
		ConfirmPopupModule,
		DialogModule,
		CheckboxModule,
		MessageModule,
		RadioButtonModule,
		CardModule,
		DividerModule,
		ProgressSpinnerModule,
		TooltipModule,
		AutoCompleteModule,
		InplaceModule
	],
	exports: [
		TrustHtmlPipe,
		TrustResourcePipe,
		FilterByPipe,
		InfiniteTableDirective,
		TextEditorComponent,
		AngularElementEventDirective,
		CommentListComponent,
		ExportDialogComponent,
		EntityPagerComponent,
		MiddleClickDirective,
		PaneledViewerComponent,
		ResizeObserverDirective,
		LoadingIndicatorComponent,
		ContainerDirective,
		InplaceEditorComponent,
		VarDirective,
		FormInputDialogComponent
	]
})
export class SharedModule { }